import { useCallback } from 'react';
import { AModal } from '../../../components';
import { useToast } from '../../../hooks/toast';
import { IUser } from '../../../shared/interfaces';
import { patchResetPassword } from '../../../http';
import { useI18n } from '../../../shared/i18n';

interface IResetPasswordProps {
  open: boolean;
  close: () => void;
  userEdited: IUser | null;
}

const ResetPassword: React.FC<IResetPasswordProps> = ({
  open,
  close,
  userEdited,
}) => {
  const { addToast } = useToast();
  const { t } = useI18n();
  const handleReset = useCallback(async () => {
    await patchResetPassword(userEdited?.id)
      .then(() => {
        addToast({
          type: 'success',
          title: t('usersPage.resetPassword.successTitle'),
          description: t('usersPage.resetPassword.successDescription'),
        });
        close();
      })
      .catch((error) => {
        addToast({
          type: 'error',
          title: t('usersPage.toast.errorTitle'),
          description:
            error.response.data.error ??
            t('usersPage.resetPassword.errorDescription'),
        });
      });
  }, [addToast, close, userEdited, t]);

  return (
    <AModal
      open={open}
      title={t('usersPage.resetPassword.modalTitle')}
      close={close}
      onOk={handleReset}
      okText={t('usersPage.resetPassword.confirmButton')}
    >
      {t('usersPage.resetPassword.description')}
    </AModal>
  );
};

export default ResetPassword;
